/* eslint-disable no-unused-vars */
import axios from '../axios'
import pouchdb from '../pouchdb'
import configurations from '../configurations'
const workerApi = configurations.WORKER

const search = {
  namespaced: true,
  state: {
    council: configurations.council,
    currentPage: '',
    data: {},
    trading_payments: [],
    form: { id: '' },
    database: '',
    error: null,
    listData: [],
    loading: false,
    years: [],
    metadata: {
      early_renewal: false,
      license_system_year: new Date().getFullYear()
    },
    dbLastUpdated: null,
    lastPayment: {}
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setCurrentPage (state, payload) {
      state.currentPage = payload.currentPage
    },
    setData (state, payload) {
      state.data = payload.data
    },
    setDatabase (state, payload) {
      state.database = payload.database
    },
    setDBLastUpdated: function (state, payload = { dbLastUpdated: null }) {
      state.dbLastUpdated = payload.dbLastUpdated
    },
    setError (state, payload) {
      state.error = payload.error
    },
    setForm (state, { form }) {
      state.form = Object.assign({}, state.form, form)
    },
    setListData (state, payload) {
      state.listData = payload.listData
    },
    setLoading (state, payload) {
      state.loading = payload.loading
    },
    setTradingPayments (state, tradingPayments) {
      state.trading_payments = tradingPayments
    },
    setMetadata (state, { metadata }) {
      state.metadata = metadata
    },
    setLastPayment: function (state, payload = { lastPayment: {} }) {
      state.lastPayment = payload.lastPayment
    },
    setYears (state, { years }) {
      state.years = years
    },
    resetData (state) {
      state.data = {}
      state.form = { id: '' }
      state.lastPayment = {}
      state.years = []
      state.trading_payments = []
    }
  },
  actions: {
    searchID: async function (context) {
      context.commit('setLoading', { loading: true })
      try {
        const id = context.state.form.id
        const response = await axios.post(configurations.WORKER + `/query`, { url: btoa(`apply_trading/${id}`) })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error: { message: 'Data Not Found' } })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    searchTradingWorkflow: async function (context) {
      context.commit('setLoading', { loading: true })
      try {
        const id = context.state.form.id
        const response = await axios.post(
          `${configurations.host.EPBT3_middleware}/_trading/searchWorkflow`, {
            query: id, workflow_type: 'application'
          }
        )
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error: { message: 'Data Not Found' } })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    async fetchData (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        if (payload.type === 'assessment' && payload.id.startsWith(`ASVI-`)) {
          const { data } = await axios.post(configurations.WORKER + `/search`, { data: {
            _id: btoa(payload.id),
            council: 'mdkgu',
            payment_type: 'assessment'
          } })
          context.commit('setData', { data })
          context.commit('setLoading', { loading: false })
          return
        }

        if (payload.type.startsWith(`license`) || payload.type.startsWith(`permit`)) {
          const { data } = await axios.post(configurations.WORKER + `/search`, { data: {
            _id: btoa(payload.id),
            council: 'mdkgu',
            payment_type: payload.type
          } })
          context.commit('setData', { data })
          return
        }
      } catch (error) {
        context.commit('setError', { error: error })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    async fetchTradingRenewal (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        const id = payload.id.trim()
        const { data: mandate } = await axios.get(configurations.WORKER + `/licenses/license_trading/mandate`)
        context.commit('setMetadata', { metadata: {
          early_renewal: mandate.early_renewal,
          license_system_year: mandate.system_year
        } })
        const years = [
          context.state.metadata.license_system_year,
          (context.state.metadata.early_renewal
            ? context.state.metadata.license_system_year + 1
            : null)
        ]
        context.commit('setYears', { years })
        const res = await axios.post(configurations.WORKER + `/search`, {
          data: {
            _id: btoa(id),
            council: 'mdkgu',
            payment_type: `license_trading`
          }
        })
        const data = res.data
        context.commit('setData', { data })

        let tradingPayments = [
          {
            jenis_bayaran: 'license_trading',
            ruj_akaun: data.no_lesen,
            bayaran: data.full_payment - data.minimum_payment,
            bayaran2: data.full_payment2 - data.minimum_payment2
          },
          {
            jenis_bayaran: 'process_fee',
            ruj_akaun: data.no_lesen,
            bayaran: data.minimum_payment,
            bayaran2: data.minimum_payment2
          }
        ]
        tradingPayments = tradingPayments.concat(data.renew_Trading)
        context.commit('setTradingPayments', tradingPayments)
      } catch (error) {
        context.commit('setError', { error: error })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    patchData (context, payload) {
      const data = Object.assign({}, context.state.data, payload)
      context.commit('setData', { data })
    },
    resetData (context) {
      context.commit('setData', { data: {} })
      context.commit('setError', { error: null })
      context.commit('setListData', { listData: [] })
    },
    async searchData (context) {
      context.commit('setLoading', { loading: true })

      const currentRoute = context.rootState.route.path
      let currentPage = currentRoute.replace(/\//g, '')
      context.commit('setCurrentPage', { currentPage })
      let response
      const data = await Object.assign({}, context.state.data)
      const searchIndex = data.searchId && data.searchId.match(/^\d{6}-\d{2}-\d{4}$/) ? data.searchId.trim().replace(/-/g, '') : data.searchId.trim()

      if (currentPage.includes('license') || currentPage.includes('trading')) {
        response = await axios.get(configurations.WORKER + `/licenses`, {
          params: {
            id: btoa(searchIndex),
            type: currentPage.includes('trading') ? 'trading_license' : currentPage
          }
        })
      }

      try {
        if (currentPage === 'assessment') {
          response = await axios.post(configurations.WORKER + `/assessments`, { data: {
            _id: searchIndex,
            council: configurations.council,
            payment_type: '',
            compound_type: '',
            database: ''
          } })
        }
        if (currentPage === 'compound') {
          response = await axios.post(configurations.WORKER + `/compounds`, { data: {
            _id: searchIndex.toString().trim().replace(/-/g, ''),
            council: configurations.council,
            payment_type: '',
            compound_type: '',
            database: ''
          } }, {
            baseURL: configurations.WORKER,
            withCredentials: configurations.withCredentials
          })
        }
        if (response.data.rows.length === 0) {
          context.commit('setError', {
            error: { message: 'Record Not found!' }
          })
        } else {
          context.commit('setError', { error: null })
        }
        context.commit('setListData', { listData: response ? response.data.rows : [] })
        context.commit('setData', { data: {} })
        context.commit('setLoading', { loading: false })
        return response
      } catch (error) {
        context.commit('setError', { error })
        return error
      } finally {
        context.commit('setData', { data: {} })
        context.commit('setLoading', { loading: false })
      }
    },
    async searchTrading (context) {
      context.commit('setLoading', { loading: true })

      const currentRoute = context.rootState.route.path
      let currentPage = currentRoute.substr(currentRoute.lastIndexOf('/') + 1)
      context.commit('setCurrentPage', { currentPage })
      const databaseType = 'license'
      const council = context.state.council
      try {
        const response = await axios.post(configurations.WORKER + `/query`, { url: btoa(`/metadata/metadata`) })
        context.commit('setDatabase', {
          database: response.data[council][databaseType]
        })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        throw error
      }
      const database = context.state.database
      const data = await Object.assign({}, context.state.data)
      const searchIndex1 = data.trading_no ? data.trading_no.trim().replace(/-|\s/g, '').replace(/[-\s,`.]/g, '').toUpperCase() : null
      const searchIndex2 = data.ic_no ? data.ic_no.trim().replace(/-|\s/g, '') : null
      const apiUrl = `/${database}/_design/trading/_view/by-company?key="${searchIndex1}"&include_docs=true`
      // const apiUrl = `/${database}/_design/search/_view/index-trading?key=["${searchIndex1}"]&include_docs=true`
      // let apiUrl = `/${database}/_design/search/_view/index-trading-nric?key=["${searchIndex1}","${searchIndex2}"]&include_docs=true`

      try {
        let response = await axios.post(configurations.WORKER + `/query`, { url: btoa(apiUrl) })
        if (response.data.rows.length > 0) {
          let listData = response.data.rows.map(row => row.doc)
          context.commit('setListData', { listData })
          context.commit('setError', { error: null })
        } else {
          response = await axios.post(`${configurations.WORKER}/query`, { url: btoa(`/${database}/_find`),
            payload: {
              selector: {
                m_kod_type: { $eq: 'niaga' },
                nama_s: {
                  $regex: `^.*${data.trading_no.trim().toUpperCase()}.*$`
                }
              },
              use_index: 'by-company-name-index'
            }
          })
          if (response.data.docs.length) {
            let listData = response.data.docs
            context.commit('setListData', { listData })
            context.commit('setError', { error: null })
          } else {
            context.commit('setError', {
              error: { message: 'Record Not found!' }
            })
            context.commit('setListData', { listData: [] })
          }
        }
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        return error
      } finally {
        context.commit('setData', { data: {} })
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default search
